// -------------------------
// waitUntil helper
// -------------------------
window.requestAnimationFrame =
  window.requestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.msRequestAnimationFrame ||
  function (cb) { return setTimeout(cb, 1000 / 60); };

function waitUntil(conditionFn) {
  return new Promise((resolve) => {
    function check() {
      if (conditionFn()) {
        resolve();
      } else {
        requestAnimationFrame(check);
      }
    }
    check();
  });
}

// -------------------------
// eleReady helper
// -------------------------
function eleReady(selector, callback) {
  const observer = new MutationObserver(() => {
    const el = document.querySelector(selector);
    if (el) callback(el);
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
}

// -------------------------
// Cart Functions
// -------------------------
async function fetchProductVariants(slug) {
  const url = window.Shopify.routes.root + `products/${slug}.js`;

  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error("Failed to fetch product");
    }

    const product = await response.json();
    return product.variants;
  } catch (error) {
    console.error("Error fetching product variants:", error);
    return null;
  }
}

async function refreshCartUI() {
  try {
    const response = await fetch("/cart.js");
    if (!response.ok) throw new Error("Failed to fetch cart");
    const cart = await response.json();

    if (typeof window.sharedFunctions?.updateSidebarCart === "function") {
      window.sharedFunctions.updateSidebarCart(cart);
    }
  } catch (err) {
    console.error("Error refreshing cart UI:", err);
  }
}

function addToCart(variantId, quantity = 1) {
  const formData = {
    id: variantId,
    quantity: quantity,
  };

  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((res) => res.json())
    .then(() => {
      refreshCartUI();
      // Close modal after adding to cart
      const modal = document.querySelector('.CP-size-modal.CP_MS_Cart_Drawer_30');
      if (modal) {
        modal.style.display = 'none';
      }
    })
    .catch((err) => {
      console.error("Error adding to cart:", err);
      alert("Failed to add product to cart. Please try again.");
    });
}

// -------------------------
// Update Variant Indicator
// -------------------------
function updateVariantIndicator(variantTitle) {
  const modal = document.querySelector('.CP-size-modal.CP_MS_Cart_Drawer_30');
  if (!modal) return;
  
  const indicatorValue = modal.querySelector('.CP-main-indicate-value');
  if (indicatorValue) {
    indicatorValue.textContent = variantTitle;
  }
}

// -------------------------
// Modal Functions
// -------------------------
function createModal() {
  // Check if modal already exists
  if (document.querySelector('.CP-size-modal.CP_MS_Cart_Drawer_30')) {
    return;
  }

  const popupHTML = `
  <div class="CP-size-modal CP_MS_Cart_Drawer_30" style="display:none;" id="CP-size-modal">
    <div class="CP-modal-content">
      <div class="CP-modal-header">
        <h3 class="CP-modal-title">CHOOSE OPTIONS</h3>
        <button class="CP-close-btn"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M 38.982422 6.9707031 A 2.0002 2.0002 0 0 0 37.585938 7.5859375 L 24 21.171875 L 10.414062 7.5859375 A 2.0002 2.0002 0 0 0 8.9785156 6.9804688 A 2.0002 2.0002 0 0 0 7.5859375 10.414062 L 21.171875 24 L 7.5859375 37.585938 A 2.0002 2.0002 0 1 0 10.414062 40.414062 L 24 26.828125 L 37.585938 40.414062 A 2.0002 2.0002 0 1 0 40.414062 37.585938 L 26.828125 24 L 40.414062 10.414062 A 2.0002 2.0002 0 0 0 38.982422 6.9707031 z"></path></svg></button>
      </div>

      <div class="CP-main-indicate">Size: <span class="CP-main-indicate-value"></span></div>
      
      <div class="CP-product-size"></div>

      <div class="CP-quantity">
        <label>Quantity:</label>
        <div class="CP-quantity-box">
          <button class="CP-qty-btn minus">−</button>
          <input type="text" value="1" />
          <button class="CP-qty-btn plus">+</button>
        </div>
      </div>

      <div class="CP-modal-actions">
        <button class="CP-cancel-btn">CANCEL</button>
        <button class="CP-product-atc">Add to Cart</button>
      </div>
    </div>
  </div>
  `;

  document.querySelector("body").insertAdjacentHTML("beforeend", popupHTML);
  
  // Setup modal event listeners
  setupModalEvents();
}

function setupModalEvents() {
  const modal = document.querySelector('.CP-size-modal.CP_MS_Cart_Drawer_30');
  if (!modal) return;

  // Close button
  const closeBtn = modal.querySelector('.CP-close-btn');
  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      modal.style.display = 'none';
    });
  }

  // Cancel button
  const cancelBtn = modal.querySelector('.CP-cancel-btn');
  if (cancelBtn) {
    cancelBtn.addEventListener('click', () => {
      modal.style.display = 'none';
    });
  }

  // Quantity buttons
  const minusBtn = modal.querySelector('.CP-qty-btn.minus');
  const plusBtn = modal.querySelector('.CP-qty-btn.plus');
  const qtyInput = modal.querySelector('.CP-quantity-box input');

  if (minusBtn) {
    minusBtn.addEventListener('click', () => {
      let val = parseInt(qtyInput.value) || 1;
      if (val > 1) {
        qtyInput.value = val - 1;
      }
    });
  }

  if (plusBtn) {
    plusBtn.addEventListener('click', () => {
      let val = parseInt(qtyInput.value) || 1;
      qtyInput.value = val + 1;
    });
  }

  // Close on background click
  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      modal.style.display = 'none';
    }
  });
}

async function openVariantModal(productHandle) {
  const modal = document.querySelector('.CP-size-modal.CP_MS_Cart_Drawer_30');
  if (!modal) return;

  // Show modal with loading state
  modal.style.display = 'flex';
  const sizeContainer = modal.querySelector('.CP-product-size');
  sizeContainer.innerHTML = '<p>Loading variants...</p>';

  // Fetch variants
  const variants = await fetchProductVariants(productHandle);
  
  if (!variants || variants.length === 0) {
    sizeContainer.innerHTML = '<p>No variants available</p>';
    return;
  }

  // Build variant options HTML
  let variantsHTML = '<div class="CP-variants-list">';
  
  // Find first available variant
  let firstAvailableVariant = variants.find(v => v.available) || variants[0];
  
  variants.forEach((variant) => {
    const available = variant.available ? '' : 'disabled';
    const availableText = variant.available ? '' : ' (Sold Out)';
    const price = (variant.price / 100).toFixed(2);
    const isChecked = variant.id === firstAvailableVariant.id;
    
    variantsHTML += `
      <label class="CP-variant-option ${available}">
        <input type="radio" name="variant" value="${variant.id}" data-variant-title="${variant.title}" ${isChecked ? 'checked' : ''} ${available} />
        <span class="CP-variant-label">
          <span class="CP-variant-title">${variant.title}</span>
        </span>
      </label>
    `;
  });
  
  variantsHTML += '</div>';
  sizeContainer.innerHTML = variantsHTML;

  // Set initial variant title in indicator
  updateVariantIndicator(firstAvailableVariant.title);

  // Add change event listener to radio buttons
  const radioButtons = sizeContainer.querySelectorAll('input[name="variant"]');
  radioButtons.forEach(radio => {
    radio.addEventListener('change', (e) => {
      const selectedTitle = e.target.getAttribute('data-variant-title');
      updateVariantIndicator(selectedTitle);
    });
  });

  // Setup Add to Cart button
  const addBtn = modal.querySelector('.CP-product-atc');
  const qtyInput = modal.querySelector('.CP-quantity-box input');
  
  // Remove old event listeners by cloning
  const newAddBtn = addBtn.cloneNode(true);
  addBtn.parentNode.replaceChild(newAddBtn, addBtn);
  
  newAddBtn.addEventListener('click', () => {
    const selectedVariant = modal.querySelector('input[name="variant"]:checked');
    if (!selectedVariant) {
      alert('Please select a variant');
      return;
    }
    
    const variantId = selectedVariant.value;
    const quantity = parseInt(qtyInput.value) || 1;
    
    addToCart(variantId, quantity);
  });
}

// -------------------------
// Create Product Card HTML
// -------------------------
function createProductCard(product) {
  const variant = product.variants && product.variants[0] ? product.variants[0] : null;
  
  const price = variant ? (variant.price / 100).toFixed(2) : '0.00';
  const comparePrice = variant && variant.compare_at_price ? (variant.compare_at_price / 100).toFixed(2) : null;
  const image = product.featured_image || (product.images && product.images[0]) || '';
  
  const currencySymbol = window.Shopify?.currency?.active === 'INR' ? 'Rs.' : (window.Shopify?.currency?.active || '$');
  
  const priceHTML = comparePrice && parseFloat(comparePrice) > parseFloat(price)
    ? `<span class="price price--on-sale">
        <span class="price__regular">${currencySymbol} ${price}</span>
        <s class="price__compare">${currencySymbol} ${comparePrice}</s>
      </span>`
    : `<span class="price">${currencySymbol} ${price}</span>`;
  
  return `
    <div class="recent-product-item" data-product-handle="${product.handle}">
      <a href="/products/${product.handle}" class="recent-product-link">
        <div class="recent-product-image">
          ${image ? `<img src="${image}" alt="${product.title}" loading="eager" />` : '<div class="no-image">No Image</div>'}
        </div>
      </a>
      <div class="recent-product-info">
      <a href="/products/${product.handle}" class="recent-product-link-title">
          <h3 class="recent-product-title">${product.title}</h3>
          </a>
        </div>
        <div class="recent-product-button">
      <div class="recent-product-price">${priceHTML}</div>
      <button class="recent-product-cart-btn" data-product-handle="${product.handle}">
        <img src="https://cdn.shopify.com/s/files/1/0496/1003/1256/files/cartIcon.png?v=1750331068" class="CP-cart-icon" alt="Cart Icon">
      </button>
      </div>
    </div>
  `;
}

// -------------------------
// MAIN LOGIC FUNCTION
// -------------------------
async function loadRecentlyViewedProducts(container) {
  const KEY = "shopify_recently_viewed";
  
  const stored = localStorage.getItem(KEY);
  let handles = stored
    ? stored
        .split(" ")
        .map(h => (h ? h.trim() : ""))
        .filter(Boolean)
    : [];

  console.log("Parsed handles:", handles);

  if (!handles.length) {
    console.log("No handles saved in localStorage for key:", KEY);
    container.innerHTML = '<p class="no-recent-products">No recently viewed products</p>';
    container.closest(".recently-viewed-wrapper").classList.add('hide');
    return;
  }

  const LIMIT = 3;
  let appendedCount = 0;

  if (!container.children.length) {
    container.innerHTML = '<div class="recent-products-loading">Loading recently viewed...</div>';
  }

  const tempContainer = document.createElement('div');
  tempContainer.className = 'recent-products-grid';

  // Process handles sequentially
  for (const handle of handles) {
    if (appendedCount >= LIMIT) break;

    const url = "/products/" + encodeURIComponent(handle) + ".js";
    console.log("Requesting product JSON:", url);

    try {
      const response = await fetch(url);
      
      if (!response.ok) {
        console.log("Failed to fetch product:", handle, response.status);
        continue;
      }

      const product = await response.json();
      console.log("Product data:", product);

      // Create and append product card
      const productHTML = createProductCard(product);
      tempContainer.insertAdjacentHTML("beforeend", productHTML);
      appendedCount++;
      console.log("Appended product #", appendedCount, ":", product.title);

    } catch (err) {
      console.log("Error fetching product:", handle, err);
    }
  }

  // Update container with all products at once
  if (appendedCount === 0) {
    container.innerHTML = '<p class="no-recent-products">No recently viewed products available</p>';
    container.closest(".recently-viewed-wrapper").classList.add('hide');
  } else {
    // Add styling
    addStyles();
    
    // Add modal to body
    createModal();
    
    container.innerHTML = tempContainer.outerHTML;
    
    // Setup cart button event listeners
    setupCartButtonListeners(container);
  }

  console.log("Finished. Total products appended:", appendedCount);
}

// -------------------------
// Setup Cart Button Listeners
// -------------------------
function setupCartButtonListeners(container) {
  const cartButtons = container.querySelectorAll('.recent-product-cart-btn');
  
  cartButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      const productHandle = button.getAttribute('data-product-handle');
      if (productHandle) {
        openVariantModal(productHandle);
      }
    });
  });
}

// -------------------------
// Add Styles
// -------------------------
function addStyles() {
  if (document.getElementById('recent-products-style')) return;
  
  const style = document.createElement('style');
  style.id = 'recent-products-style';
  style.textContent = `
    .recent-products-grid {
      display: grid;
      gap: 15px;
      margin: 10px 0;
    }
    .recent-product-cart-btn {
      background: white;
  width: 14px;
    height: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.2s;
      padding: 0;
    }
  

    .recent-products-loading,
    .no-recent-products {
      padding: 20px;
      text-align: center;
      color: #666;
      font-size: 14px;
    }
    
    .CP-main-indicate {
      margin-bottom: 15px;
      font-size: 14px;
      font-weight: 500;
    }
    
    .CP-main-indicate-value {
      font-weight: 600;
      color: #333;
    }
  
    .CP-modal-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;

    }
    .CP-modal-title {
      margin: 0;
      font-size: 18px;
      font-weight: 600;
    }
    .CP-close-btn {
      background: none;
      border: none;
      cursor: pointer;
      padding: 5px;
      width: 30px;
      height: 30px;
    }
    .CP-close-btn svg {
      width: 100%;
      height: 100%;
    }
    .CP-product-size {
      margin-bottom: 20px;
    }
    .CP-variants-list {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
    .CP-variant-option {
      display: flex;
      align-items: center;
      padding: 12px;
      border: 1px solid #e0e0e0;
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.2s;
    }
    .CP-variant-option:hover:not(.disabled) {
      border-color: #333;
      background: #f9f9f9;
    }
    .CP-variant-option.disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
    .CP-variant-option input[type="radio"] {
      margin-right: 10px;
    }
    .CP-variant-label {
      display: flex;
      justify-content:center;
      align-items:center;
    }
    .CP-variant-title {
      font-weight: 500;
    }
    .CP-variant-price {
      font-weight: 600;
    }
    .CP-quantity {
      margin-bottom: 20px;
    }
    .CP-quantity label {
      display: block;
      margin-bottom: 8px;
      font-weight: 500;
    }
    .CP-quantity-box {
      display: flex;
      align-items: center;
      border: 1px solid #e0e0e0;
      border-radius: 4px;
      width: fit-content;
    }
    .CP-qty-btn {
      background: white;
      border: none;
      padding: 10px 15px;
      cursor: pointer;
      font-size: 18px;
      transition: background 0.2s;
    }
    .CP-qty-btn:hover {
      background: #f5f5f5;
    }
    .CP-quantity-box input {
      border: none;
      text-align: center;
      width: 50px;
      padding: 10px;
      font-size: 14px;
    }
    .CP-modal-actions {
      display: flex;
      gap: 10px;
      margin-top: 20px;
    }
    .CP-cancel-btn,
    .CP-product-atc {
      flex: 1;
      padding: 12px 20px;
      border: none;
      border-radius: 4px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.2s;
    }
    .CP-cancel-btn {
      background: #f5f5f5;
      color: #333;
    }
    .CP-cancel-btn:hover {
      background: #e0e0e0;
    }
    .CP-product-atc {
      background: #333;
      color: white;
    }
    .CP-product-atc:hover {
      background: #000;
    }
  `;
  
  document.head.appendChild(style);
}

// -------------------------
// INIT LOGIC
// -------------------------
function initMyFeature() {
  console.log("INIT triggered for recently viewed products");

  const container = document.querySelector(".revamp-cart-drawer-recent-view");
  
  if (!container) {
    console.log("Container .revamp-cart-drawer-recent-view not found in DOM.");
    return;
  }

  if (container.hasAttribute("data-recently-viewed-loaded")) {
    console.log("Recently viewed products already loaded for this container");
    return;
  }

  container.setAttribute("data-recently-viewed-loaded", "true");
  
  console.log("Loading recently viewed products...");
  loadRecentlyViewedProducts(container);
}

// -------------------------
// SETUP TRIGGERS
// -------------------------

// First check on initial page load
waitUntil(() => document.querySelector(".revamp-cart-drawer-recent-view"))
  .then(() => {
    console.log("waitUntil: .revamp-cart-drawer-recent-view found");
    initMyFeature();
  });

// Detect every time Shopify re-renders drawer
eleReady(".revamp-cart-drawer-recent-view", function (el) {
  console.log("eleReady: .revamp-cart-drawer-recent-view appeared");
  
  if (!el.hasAttribute("data-recently-viewed-loaded")) {
    setTimeout(() => {
      initMyFeature();
    }, 100);
  } else {
    console.log("Container already has loaded data, skipping reload");
  }
});